const REGISTRATION_TYPE_INVITE = 'employee_invite';
const REGISTRATION_TYPE_ADMIN = 'dotorg_admin';

export { REGISTRATION_TYPE_INVITE, REGISTRATION_TYPE_ADMIN };
